import { Component, ChangeDetectionStrategy, Input, computed, inject } from '@angular/core';
import { DmsBaseFolderAction } from '../dms-base-folder-action';
import { IrisDmsFoldersSandbox } from '@iris/common/modules/dms/sandbox/dms-folders.sandbox';
import { IrisDmsRootFolderId } from '@iris/common/modules/dms/models/IrisDMSFolder';
import { IrisDmsSelectionService } from '@iris/modules/dms/services/dms-selection.service';
import { IrisDmsSidebarSandbox } from '@iris/common/modules/dms/sandbox/dms-sidebar.sandbox';
import { toSignal } from '@angular/core/rxjs-interop';
import { filter, switchMap } from 'rxjs';
import { NgClass } from '@angular/common';
import { MatTooltipModule } from '@angular/material/tooltip';
import { StrakitButtonComponent } from '@ngx-strakit/cdk/controls';
import { StrakitButtonPrefixDirective } from '@ngx-strakit/cdk';
import { MatMenuItem } from '@angular/material/menu';

@Component({
  selector: 'iris-dms-show-folder-info-button',
  templateUrl: './dms-show-folder-info-button.component.html',
  styleUrls: ['./dms-show-folder-info-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    NgClass,
    MatTooltipModule,
    StrakitButtonComponent,
    StrakitButtonPrefixDirective,
    MatMenuItem,
  ],
})
export class IrisDmsShowFolderInfoButtonComponent extends DmsBaseFolderAction {
  private readonly dmsFoldersSandbox = inject(IrisDmsFoldersSandbox);
  private readonly dmsSelectionService = inject(IrisDmsSelectionService);
  private readonly dmsSidebarSandbox = inject(IrisDmsSidebarSandbox);

  @Input() openFolderOnShowInfo = false;

  protected _label = 'label.dms.ShowFolderInfo';

  private readonly folder = toSignal(this.folderId$.pipe(
    filter(Boolean),
    switchMap(folderId => this.dmsFoldersSandbox.getFolderById$(folderId)),
  ));

  private readonly parentId = computed(() => this.folder()?.parentId);

  openFolderInfo(): void {
    this.dmsSidebarSandbox.showFolderSidebar(this.folderId());
    if (this.openFolderOnShowInfo) {
      this.dmsFoldersSandbox.setSelectedFolder(this.folderId());
      if (!!this.parentId() && this.parentId() !== IrisDmsRootFolderId) {
        this.dmsFoldersSandbox.expandFolder(this.parentId(), this.folder().isSystem);
      }
    } else {
      this.dmsSelectionService.changeSelection(this.folder(), true, true);
    }
  }
}
